import {Grid, Typography} from "@material-ui/core";
import {useSelector} from "react-redux";
import PianoOpzioniCard from "./offerte-cards/piano-opzioni-card/PianoOpzioniCard";
import ExtraShareCard from "./offerte-cards/extra-share-card/ExtraShareCard";

const Offerte = () => {
    const tablesData = useSelector(state => state.contrattoDigitaleReducer.contractTablesData.data)
    const loading = useSelector(state => state.contrattoDigitaleReducer.contractTablesData.loading)
    const cacheLoading = useSelector((state) => state.authReducer.cacheDigitalContractLoading)

    return <Grid item container
                 spacing={3}
                 xs={12}>
        <Grid item
              xs={12}>
            <Typography variant="h6" className="mb-6">Offerte incluse nel contratto</Typography>
        </Grid>

        <Grid item
              xs={12}>
            <PianoOpzioniCard
                cardTitle="Piani commerciali sottoscritti"
                tableOneDescription="Voce e Dati"
                tableOneData={tablesData.planVoiceDataList}
                tableTwoDescription="Dati"
                tableTwoData={tablesData.planDataList}
                loading={loading || cacheLoading}
            />
        </Grid>

        <Grid item
              xs={12}>
            <PianoOpzioniCard
                cardTitle="Opzioni non in bundle col piano commerciale"
                optionsTable={true}
                tableOneData={tablesData.optionsList}
                loading={loading || cacheLoading}
            />
        </Grid>

        <Grid item
              xs={12}>
            <ExtraShareCard
                attiviTableData={tablesData.extraSharesActiveList}
                daAttivareTableData={tablesData.extraSharesNotActiveList}
                loading={loading || cacheLoading}
            />
        </Grid>
    </Grid>
}

export default Offerte;
